import React from 'react';

import BSResults from './BSResults';
import BSSlider from './BSSlider';
import BSColorPicker from './BSColorPicker';

import '../styles/boxshadow-styles.css';

class BoxShadow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {horizontalLength: 10, verticalLength: 10, blurRadius: 0, spreadRadius: 0, shadowColor: "#FF1500", backgroundColor: "#FFFFFF", boxColor: "#DDDDDD", opacity: 1  };
  }

  handleSliderChange = (name, val) =>{
    this.setState({[name]: val});
  }

  handlePickerChange = (name, val) =>{
    this.setState({[name]: val});
  }







  render() {
    return (
      <div className="ui segment flex-ed main-container">

        <div className="ui segment">
          <h2 className="center">Box Shadow Generator</h2>

          <form className="ui form">
            <div className="field">
              <label htmlFor="horizontalLength" >Horizontal Length</label>
              <BSSlider name="horizontalLength" min={-500} max={500} value={this.state.horizontalLength} onSliderChange={this.handleSliderChange}  />
              <label htmlFor="verticalLength" >Vertical Length</label>
              <BSSlider name="verticalLength" min={-500} max={500} value={this.state.verticalLength} onSliderChange={this.handleSliderChange}  />
              <label htmlFor="blurRadius" >Blur Radius</label>
              <BSSlider name="blurRadius" min={0} max={500} value={this.state.blurRadius} onSliderChange={this.handleSliderChange}  />
              <label htmlFor="spreadRadius" >Spread Radius</label>
              <BSSlider name="spreadRadius" min={0} max={500} value={this.state.spreadRadius} onSliderChange={this.handleSliderChange}  />
              <label htmlFor="opacity" >Opacity</label>
              <BSSlider name="opacity" min={0} max={1} steps={.01} value={this.state.opacity} onSliderChange={this.handleSliderChange}  />
              <div className="BS-picker-container">
              <div><label htmlFor="shadowColor" >Box Shadow Color</label>
                            <BSColorPicker name="shadowColor" value={this.state.shadowColor} onPickerChange={this.handlePickerChange} /></div>

              <div><label htmlFor="boxColor" >Box Color</label>
                            <BSColorPicker name="boxColor" value={this.state.boxColor} onPickerChange={this.handlePickerChange} /></div>

              <div><label htmlFor="backgroundColor" >Container Background Color</label>
                            <BSColorPicker name="backgroundColor" value={this.state.backgroundColor} onPickerChange={this.handlePickerChange} /></div>
              </div>
            </div>
          </form>
        </div>
        

          <BSResults terms={this.state} />
      </div>
    );
  }

}

export default BoxShadow;